import { Box, Button, CircularProgress, Tab, Tabs, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { MyWorkItemList } from "../components/MyWorkItemList";
import { useMyWorkCount } from "../hooks/useMyWorkCount";
import { myWorkApi, myWorkKeys, WorkKind, WorkScope } from "../services/my-work-api";

export default function MyWorkPage() {
    const { t } = useTranslation();
    const [params, setParams] = useSearchParams();
    const kind: WorkKind = params.get("tab") === "approval" || params.get("tab") === "approvals" ? "approval" : "task";
    const { scope, setScope, count } = useMyWorkCount();
    const [input, setInput] = useState("");
    const [search, setSearch] = useState("");
    useEffect(() => { const timer = window.setTimeout(() => setSearch(input), 300); return () => window.clearTimeout(timer); }, [input]);
    const items = useInfiniteQuery({ queryKey: myWorkKeys.items(scope, kind, 50, 0, search),
        initialPageParam: 0,
        queryFn: ({ pageParam }) => myWorkApi.listItems({ scope, kind, limit: 50, offset: pageParam, search }),
        getNextPageParam: (last, pages) => last.items.length === 50 ? pages.length * 50 : undefined });
    const rows = items.data?.pages.flatMap(page => page.items) || [];
    return <Box sx={{ maxWidth: 920, mx: "auto", p: 3 }}>
        <Typography variant="h4" component="h1">{t("my_work.title")}</Typography>
        <ToggleButtonGroup value={scope} exclusive size="small" sx={{ my: 2 }} aria-label={String(t("my_work.scope_label"))}
            onChange={(_, value: WorkScope | null) => { if (value) void setScope(value); }}>
            <ToggleButton value="mine">{t("my_work.scope.mine")}</ToggleButton>
            <ToggleButton value="mine_and_groups">{t("my_work.scope.mine_and_groups")}</ToggleButton>
        </ToggleButtonGroup>
        <Tabs value={kind} onChange={(_, value: WorkKind) => setParams({ tab: value === "approval" ? "approvals" : "tasks" })}>
            <Tab value="task" label={`${t("my_work.tabs.tasks")} (${count.data?.tasks ?? 0})`} />
            <Tab value="approval" label={`${t("my_work.tabs.approvals")} (${count.data?.approvals ?? 0})`} />
        </Tabs>
        <TextField fullWidth size="small" sx={{ mt: 2 }} label={t("my_work.search_placeholder")}
            value={input} onChange={event => setInput(event.target.value)} />
        {items.isLoading ? <CircularProgress sx={{ m: 3 }} /> : <MyWorkItemList items={rows} kind={kind} />}
        {items.hasNextPage && <Button disabled={items.isFetchingNextPage} onClick={() => void items.fetchNextPage()}>
            {t("my_work.load_more")}</Button>}
    </Box>;
}
